import { useEffect, useState } from 'react'
import { Card, Grid, TextField, Container, Typography } from '@mui/material'
import { makeStyles } from '@material-ui/core'
import MessageError from '../../../messages/messageError'
import api from '../../../services/api'
import { useSelector } from 'react-redux'
import MessageSuccess from '../../../messages/messageSuccess'
import HeaderGestorConfigs from '../../../utils/headerGestorConfigs'
import ButtonLeft from '../../../utils/buttonLeft'
import Loading from '../../../load/loading'
import Delete from '../../../utils/delete'


const useStyles = makeStyles((theme) => ({
    root: {
        alignItems: 'end',
    },

    gridItem: {
        padding: 5,
        // background: 'red'
    },
}))

export default function CreatePontoEntrada() {
    const classes = useStyles()
    const [pontoEntrada, setpontoEntrada] = useState('')
    const [pontoEntradas, setpontoEntradas] = useState('')
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setErrorMessage] = useState('')
    const [load, setLoad] = useState(false)
    const [open, setOpen] = useState(false)
    const user = useSelector(state => state.account.user);

    useEffect(() => {
        api.get('/ponto-entradas')
            .then(res => {
                // console.log(res)
                setpontoEntradas(res.data.pontoEntradas.sort((a, b) => a.designacao.localeCompare(b.designacao)));
            }).catch(err => '')
    }, [messageSuccess])

    function HandleChange(e) {
        setpontoEntrada({ ...pontoEntrada, [e.target.name]: e.target.value })
    }

    async function createPontoEntrada() {

        setLoad(true)
        setErrorMessage('')
        setMessageSuccess('')

        await api.post('/ponto-entrada/create', { ...pontoEntrada, userId: user?._id })
            .then(res => {
                // console.log(res)
                setLoad(false)
                setMessageSuccess(res.data.msg)

            }).catch(error => {
                // console.log(error)
                setErrorMessage(error.response.data.message)
                setLoad(false)
            })
    }


    return (
        <Container>
            <Card style={{ padding: 20, marginBottom: 20 }}>

                {messageSuccess && <MessageSuccess message={messageSuccess} />}
                {messageError && < MessageError message={messageError} />}

                {pontoEntradas ?
                    <div style={{ marginBottom: 50 }}>
                        <HeaderGestorConfigs title='Pontos de entrada:' />
                        {pontoEntradas.map((pontoEntrada) => (
                            <div key={pontoEntrada._id} style={{ position: 'relative' }}>
                                <Delete
                                    button={true}
                                    id={pontoEntrada._id}
                                    url={'/ponto-entrada/delete'}
                                    open={open === pontoEntrada._id}
                                    setOpen={setOpen}
                                    msg={'Eliminar ' + pontoEntrada.designacao}
                                />
                                <Typography variant='subtitle1' key={pontoEntrada._id} >
                                    <b> {pontoEntrada.designacao} </b>
                                </Typography>
                            </div>
                        ))}
                    </div>
                    :
                    <Loading text={'A carregar'} />
                }

                <Grid container className={classes.root}>

                    <Grid container className={classes.root}>

                        <Grid Grid xs={12} md item className={classes.gridItem}>
                            <TextField
                                style={{ marginTop: 15 }}
                                type="text"
                                required
                                label="Designação"
                                fullWidth
                                size="small"
                                name="designacao"
                                variant="outlined"
                                onChange={HandleChange}
                                defaultValue={pontoEntrada?.designacao}
                            />
                        </Grid>

                    </Grid>
                </Grid>

                <ButtonLeft
                    title={'Criar'}
                    load={load}
                    disabled={!pontoEntrada?.designacao}
                    funcao={createPontoEntrada}
                />

            </Card>
        </Container>
    )
}
